import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { ClientUsersListFilterParams } from '~bank-client-users/types'

export const clientUsersListQueryOptions = (deps: Partial<ClientUsersListFilterParams>) =>
  queryOptions({
    queryKey: ['clientUsersList', deps],
    queryFn: () => Request.post(Request.urls.bank.clientUserList, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
